// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__mD8DA","actionsCol":"EnrolledClinics_actionsCol__1Fp-f"};